import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent implements OnInit {
  scrollBottomSubscription: Subscription;

  constructor(
    public filterService: FilterService,
    public sharedService: SharedService
  ) {
    this.sharedService.setPageTitle('gallery');
  }

  ngOnInit(): void {
    // when page scroll hits bottom, get new pages
    this.scrollBottomSubscription = this.sharedService.scrollBottom.subscribe(
      () => {
        this.filterService.getPages();
        this.sharedService.logEvent('gallery_lazy_load');
      }
    );
  }

  ngOnDestroy(): void {
    this.scrollBottomSubscription.unsubscribe();
  }
}
